<style scoped lang="less">

</style>
<template>
  <div class="common-upload">
    <Upload ref="upload" type="drag" :with-credentials=true :headers="headers" :data="data" :show-upload-list=false
            :multiple="num > 1"
            :default-file-list="defaultFileList"
            :on-success="onSuccess"
            :before-upload="beforeUpload"
            accept="image/*" :action="action">
      <div style="padding: 10px 0">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>{{text}}</p>
      </div>
    </Upload>
    <ul>
      <li class="upload-list" v-for="(item, index) in fileList">
        <template v-if="item && ((!item.status) || (item.status && item.status === 'finished'))">
          <img :src="item.url">
          <div class="upload-list-cover">
            <Icon type="ios-eye-outline" v-if="isView" @click.native="handleView(index)"></Icon>
            <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
          </div>
        </template>
        <template v-else>
          <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
      </li>
    </ul>
    <div class="carousel-mask" v-if="visible" @click="onCarouselClick">
    </div>
    <div class="carousel-wrapper" v-if="visible">
      <div  style="position: fixed;z-index:2002; right: 40px; top: 20px;cursor: hand" @click="onCarouselClick">
        <Icon type="close" color="white" size="40" ></Icon>
      </div>
      <div class="carousel-content">
        <Carousel
          v-model="showIndex"
          :autoplay="false"
          :autoplay-speed="1000"
          dots="outside"
          trigger="click"
          arrow="always">
          <CarouselItem class="item" v-for="file in fileList" :key="file.url">
            <img :src="file.url" alt="" style="width: 300px">
          </CarouselItem>
        </Carousel>
      </div>
    </div>
    <!--<Modal title="查看图片" v-model="visible" :styles="{zIndex: 2000}">
      <img :src="largeImageUrl" v-if="visible" style="width: 100%">
    </Modal>-->
  </div>
</template>
<script>
  export default {
    name: 'ImageUpload',
    props: {
      defaultFileList: {
        type: [Array, Object],
        default () {
          return []
        }
      },
      params: {
        type: Object,
        default () {
          return {bucket: 'hellokid'}
        }
      },
      num: {
        type: [Number],
        default () {
          return 1
        }
      },
      text: {
        type: String,
        default () {
          return '点击或将文件拖拽到这里上传'
        }
      },
      isView: {
        type: Boolean,
        default () {
          return true
        }
      }
    },
    data () {
      return {
        action: '',
        visible: false,
        headers: {},
        data: this.params,
        largeImageUrl: '',
        fileList: [],
        fileIndex: 1,
        showIndex: 0,
        fileIndexList: [], // 按顺序存储要上传的文件
        fileUploadMap: new Map()
      }
    },
    methods: {
      handleView (index) {
        this.showIndex = index
        this.visible = true
      },
      handleRemove (file) {
        const fileList = this.fileList
        const defaultFileList = this.defaultFileList
        this.fileList.splice(fileList.map(item => item.uid).indexOf(file.uid), 1)
        this.defaultFileList.splice(defaultFileList.map(item => item.name).indexOf(file.name), 1)
        this.emitInput(this.fileList)
      },
      onSuccess (res, file, fileList) {
        if (this.fileList.length > this.num) {
          return
        }

        this.$Message.destroy()
        this.$Message.info('上传成功')
        file.uid = Date.now() + this.fileIndex++
        file.url = res.data.url
        file.name = res.data.name
        file.fileId = res.data.fileId
        file.size = res.data.size
        this.fileUploadMap.set(res.data.fileName, file)
        this.sortFileList(this.fileUploadMap)
        this.emitInput(this.fileList)
      },
      beforeUpload (file) {
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }

        if (this.fileList.length >= this.num) {
          this.$Message.warning('上传文件不能超过 ' + this.num + ' 个')
          return false
        }
        this.fileIndexList.push(file.name)
        this.$Message.loading('服务器正在处理中...', 0)
        return true
      },
      emitInput (fileList) {
        let list = []
        for (let i in fileList) {
          if (fileList[i]) {
            list.push(fileList[i])
          }
        }
        let v = list.map(item => {
          return {name: item.name, url: item.url, fileId: item.name, size: item.size}
        })
        this.$emit('on-file-change', v)
        this.$emit('input', v.map(item => item.fileId).join(','))
      },
      onCarouselClick () {
        this.visible = false
      },
      sortFileList (map) {
        this.fileList = []
        for (let i in this.defaultFileList) {
          if (this.defaultFileList[i]) {
            this.fileList.push(this.defaultFileList[i])
          }
        }
        if (!map) {
          return
        }
        if (this.fileIndexList == null || this.fileIndexList.length <= 0) {
          return
        }
        for (var index = 0; index < this.fileIndexList.length; index++) {
          if (this.fileUploadMap.get(this.fileIndexList[index])) {
            this.fileList.push(this.fileUploadMap.get(this.fileIndexList[index]))
          }
        }
      },
    },
    watch: {
      defaultFileList: function (fileList) {
        this.fileUploadMap = new Map()
        this.fileIndexList = []
        this.fileList = fileList.map(item => {
          item.status = 'finished'
          item.percentage = 100
          item.uid = Date.now() + this.fileIndex++
          return item
        })
      }
    },
    created: function () {
      this.action = this.$appConfig.baseUrl + '/upload/fileUpload'
      this.fileList = this.defaultFileList
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// ImageUpload.vue?be9514ce